import './list.less'

import React from 'react';
import {inject, observer} from 'mobx-react';
import {Checkbox, message} from 'antd';
import ClientsListView from './list-view';
import {editRequestCar} from '../../../helpers/api';
import {ClientsAdd} from './add';
import {Route} from 'react-router-dom';
import {dateFormatter, formatPassTime, passDurationText, passStatusFormatter, phoneFormatter} from './helpers';
import {mosPropNames} from './dictionaries/prop-names';
import {BaseClientsList} from './base-list';

@inject("clientsStore")
@inject("loginStore")
@observer
export default class ReqClientsList extends BaseClientsList {
  page = 'req';

  renderContent() {
    const lastPass = (property) => {
      return {
        formatter: ({ row, col }) => {
          const pass = col.isNight ? row.night_lastPass : row.lastPass;
          return pass && pass[property];
        },
        key: 'lastPass.' +  property
      };
    };

    const defaults = {
      sort: 'string',
      filterType: 'string'
    };

    const columns = {
      cid: { sort: 'number', width: 40, editable: true  },
      name: { editable: true },
      phone: { editable: true, formatter: phoneFormatter },
      email: { editable: true },
      number: { editable: true },
      'lastPass.series': { ...lastPass('series') },
      passTime: { formatter: formatPassTime },
      'lastPass.duration': { formatter: () => passDurationText },
      'lastPass.type': { ...lastPass('type'), width: 50 },
      'lastPass.status': { formatter: passStatusFormatter, filterType: 'passStatus', sort: 'passStatus' },
      'lastPass.createdAt': {
        sort: 'number',
        filterType: 'date',
        formatter: () => dateFormatter,
      },
      'lastPass.endsAt': {
        sort: 'number',
        filterType: 'date',
        formatter: () => dateFormatter,
      },
      note: { editable: true },
      sendSms: {
        width: 45,
        formatter: ({ row }) => <Checkbox checked={row.sendSms} onChange={this.onChangeSendSms.bind(this, row)}/>,
        filterType: 'bool'
      }
    };
    const splitedCols = [
      'lastPass.series', 'passTime', 'lastPass.duration', 'lastPass.type', 'lastPass.status', 'lastPass.createdAt',
      'lastPass.endsAt', 'consideration', 'considerationTemp', 'creatorName', 'price', 'paymentType', 'paymentStatus'
    ];

    const cols = Object.keys(columns)
      .map(i => ({
        key: i,
        ...defaults,
        ...columns[i],
        name: mosPropNames[i],
        splited: splitedCols.includes(i)
      }))
      .filter(col => col.enabled !== false);
    let { reqClients } = this.props.clientsStore;


    this.applyColSettings(cols);

    return (
      <div id="clients">
        <ClientsListView
          ref="listview"
          page={'req'}
          user={this.props.loginStore.user.user}
          columns={cols}
          items={reqClients}
          onChangeChecked={::this.onChangeChecked}
          onChangeEditableField={::this.onChangeEditableField}
          onChangeColSize={this.onChangeColSize.bind(this, cols)}
          onClickAction={::this.onClickAction}
        />

        <Route path="/req-clients/add" component={(props) => <ClientsAdd {...props} category={'req'}/>}/>
        {this.renderChild({ columns: cols, items: reqClients })}
      </div>
    );
  }


  async editRow(row, data) {
    return editRequestCar(row.id, data);
  }

  async checkRow(row) {
    return this.props.clientsStore.checkReq(row);
  }

  async removeRows(ids) {
    return this.props.clientsStore.removeReq(ids);
  }

  async moveRows(numbers) {
    const hide = message.loading('Перемещение в потенциальные клиенты..');
    await this.props.clientsStore.move(numbers, 'req', 'our');
    hide();
  }


  get clients() {
    return this.props.clientsStore.reqClients;
  }


}



// WEBPACK FOOTER //
// ./src/components/pages/clients/req-list.js